import MUIAppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import React from 'react';
import logo from './code-savvy-logo.png';
import DesktopMenu from './components/DesktopMenu';
import MobileMenu from './components/MobileMenu';

const useStyles = makeStyles((theme) => ({
  appBar: {
    height: 80,
    backgroundColor: '#ffffff',
    boxShadow: 'none',
  },
  logo: {
    height: 32,
  },
  title: {
    position: 'absolute',
    fontSize: 12,
    color: '#6E7687',
    marginLeft: 40,
    marginTop: -12,
    fontWeight: 400,
  },
  toolbar: {
    display: 'flex',
    height: '100%',
    justifyContent: 'space-between',
  },
  mobileToolbar: {
    justifyContent: 'flex-start',
  },
}));

const AppBar: React.SFC<{}> = () => {
  const classes = useStyles();
  const isAboveMinWidth = useMediaQuery('(min-width:980px)');

  return (
    <MUIAppBar className={classes.appBar} position="static" color="default">
      <Toolbar
        className={clsx(classes.toolbar, {
          [classes.mobileToolbar]: !isAboveMinWidth,
        })}
      >
        {!isAboveMinWidth && <MobileMenu />}
        <div>
          <img src={logo} alt="Code Savvy" className={classes.logo} />
          <Typography variant="h6" className={classes.title}>
            MNCodes Integrated Curriculum and Professional Development Resource Library
          </Typography>
        </div>
        {isAboveMinWidth && <DesktopMenu />}
      </Toolbar>
    </MUIAppBar>
  );
};

export default AppBar;
